// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lh-1";
export var messageSideRight = "_lh-2";
export var subscribeToBackInStockBubbleContainer = "_lh-0";